import type { CartLineItem, Pricing } from '@/types/checkout';
import { getCartLineItemKey, getOffersListMaxHeightPx } from '@/utils/offers';
import { useIsLandscape } from '@/hooks/useIsLandscape';
import { useIsMobile } from '@/hooks/useIsMobile';
import { OfferListItem } from './OfferListItem';

export const OffersList = ({
  lineItems,
  pricing,
}: {
  lineItems: CartLineItem[];
  pricing: Pricing;
}) => {
  const isLandscape = useIsLandscape();
  const isMobile = useIsMobile();
  const maxHeight = getOffersListMaxHeightPx({ isLandscape, isMobile });

  return (
    <div
      className="cursor-default overflow-y-auto scrollbar-hide"
      style={{ maxHeight }}
      data-testid="offers-list"
      onClick={(event) => event.stopPropagation()}
    >
      <div className="flex flex-col gap-[18px] py-[18px]">
        {lineItems.map((lineItem, index) => (
          <OfferListItem key={getCartLineItemKey(lineItem, index)} lineItem={lineItem} pricing={pricing} />
        ))}
      </div>
    </div>
  );
};
